module.exports = __webpack_public_path__ + "static/media/01-home.95f693b4.png";